/*
akhila 10/27/2022 2701012930  bre UX Changes
Suresh Peddavoora 10/28/2022 2701012930  Added Class Name for Table Enhancements
Suresh Peddavoora 10/30/2022 2701012930  Added Class Name for Button Enhancements
Ashraf 10/30/2022 2701012930 fixed table pagination  issue
Suresh Peddavoora 11/01/2022 2701012930  Modified Download configuration usage Button position in Table pagination
saikrishna 11/03/2022 2701012930 changed the paginationOptions
Sohel 11/05/2022 2701012930 rename download configurations
Akhila 11/08/2022 2701012930 added global search
Akhila 12/01/2022 2701012930 removed global search
Poornima 12/08/2022 2701012930 changed usage title
akhila 12/20/2022 2701012930 changed label for button
Ashraf 01/02/2023 2701012930 renamed usage header title
saikrishna 01/04/2023 2701012930 changed the sourceType fliter rule group to filter rule
Akhila 01/10/2023 2701012930 fixed table data issue
Raghu 03/01/2023 2701012930 fixed new ui alignments
*/

import React, {useContext, useEffect, useState} from 'react';
import {ThemeContext} from '../../../../../themes/ThemeProvider';
import {useDispatch, useSelector} from 'react-redux';
// import MaterialTable from "material-table";
import {tableIcons} from '../../../../../components/TableIcons';
import {Button, TablePagination} from '@material-ui/core';
import {resetusageRuleGroup} from '../../../../../redux/reducers/BRE/AddRuleGroup';
import {ErrorSnackbar, SuccessSnackbar} from '../../../../../components/CustomSnackBar';
import PageLoader from '../../../../../components/PageLoader';
import {postPrintUsage, resetPrintUsageData} from '../../../../../redux/reducers/printUsage';
import GuiTable from '../../../../../components/FormComponents/GuiTable';
import {ArrowBack} from '@material-ui/icons';
import {defaultRows} from '../../../../../constants/ReusableTablePagination';
import {tablePageRows} from '../../../../../constants/ReusableConstants';
import {modulesText} from '../../../../../util/Content';

const FilterRuleGroupUsage = ({setUsageState, rowdata, setValue}) => {
  const {isLoading, successMsg, errorMsg, usageFilterRuleGroupData} = useSelector(
    ({addRuleGroup}) => addRuleGroup,
  );
  const dispatch = useDispatch();
  const {reusableInputStyles} = useContext(ThemeContext);
  const [rows, setRows] = useState(defaultRows);

  const classes = reusableInputStyles();

  useEffect(() => {
    return () => {
      dispatch(resetusageRuleGroup());
    };
  }, []);
  const {
    isLoading: printUsageIsLoading,
    successMsg: printUsageSuccessMsg,
    errorMsg: printUsageErrorMsg,
  } = useSelector(({printusage}) => printusage);
  useEffect(() => {
    if (printUsageSuccessMsg || printUsageErrorMsg) {
      setTimeout(() => {
        dispatch(resetPrintUsageData());
      }, 3000);
    }
  }, [printUsageSuccessMsg, printUsageErrorMsg]);

  const object = usageFilterRuleGroupData?.placeResponse ?
    usageFilterRuleGroupData?.placeResponse :
    {};

  const values = [];
  object &&
    Object.entries(object)?.forEach(([key, value]) => {
      value?.length > 0 &&
        value?.forEach((el, i) => {
          values.push({
            frameWork: key,
            codes: el?.code,
            description: el?.description ?? '',
          });
        });
    });

  const columns = [
    {
      title: modulesText,
      field: 'frameWork',
      render: (rowData) =>
        rowData?.frameWork?.charAt(0).toUpperCase() + rowData?.frameWork?.slice(1),
    },
    {
      title: 'Name',
      field: 'codes',
      render: (rowData) => (rowData?.codes?.length > 0 ? rowData.codes : '-'),
    },
    {
      title: 'Description',
      field: 'description',
      render: (rowData) => (rowData?.description?.length > 0 ? rowData.description : '-'),
    },
  ];

  return (
    <div>
      <div className="new-standard-textfields">
        <div className={`mb-0`}>
          <div className="mb-3">
            <Button
              variant="outlined"
              type="button"
              className={`search-btn mx-1`}
              onClick={() => {
                setValue(0);
              }}
            >
              <ArrowBack className="mr-2" />
              Search Filter Rule
            </Button>
          </div>
          <div className="custom-table custom-toolbar-icons global-field-table">
            <GuiTable
              title={`${rowdata?.code?.replace(/ /g, '\u00a0')} - ${rowdata?.description?.replace(/ /g, '\u00a0')} Filter rule  has been used in the following places.`}
              columns={columns}
              icons={tableIcons}
              data={values}
              textAlign="left"
              options={{
                paging: true,
                toolbar: true,
                search: false,
                pageSize: rows,
                emptyRowsWhenPaging: false,
                headerStyle: {
                  fontWeight: 'bold',
                  fontSize: '0.938rem',
                  padding: '16px',
                },
              }}
              components={{
                Pagination: (props) => (
                  <div className="global-field-table-footer ">
                    <div className="mt-2">
                      <Button
                        type="button"
                        variant="outlined"
                        className={`mx-1 search-btn ${classes.buttonRoot}`}
                        disabled={usageFilterRuleGroupData?.userMetrix !== 'Yes'}
                        onClick={(event) => {
                          dispatch(
                            postPrintUsage({
                              code: rowdata?.code ? rowdata.code : '',
                              displayName: rowdata?.displayName ? rowdata?.displayName : '',
                              description: rowdata?.description ? rowdata.description : '',
                              returnType: rowdata?.returnType ? rowdata.returnType : '',
                              sourceType: 'FILTER RULE',
                            }),
                          );
                        }}
                      >
                        Download Configuration Usage
                      </Button>
                    </div>
                    <div className="w-50" style={{backgroundColor: 'white', border: '0px'}}>
                      <TablePagination
                        {...props}
                        SelectProps={{
                          inputProps: {'aria-label': 'Rows per screen'},
                        }}
                        labelRowsPerPage={'Rows per screen:'}
                        rowsPerPageOptions={tablePageRows}
                        onChangeRowsPerPage={(event) => {
                          props.onChangeRowsPerPage(event);
                          setRows(event.target.value);
                        }}
                      />
                    </div>
                  </div>
                ),
              }}
            />
          </div>
        </div>
      </div>
      {(isLoading || printUsageIsLoading) && <PageLoader />}
      {(errorMsg || printUsageErrorMsg) && (
        <ErrorSnackbar errorMsg={errorMsg || printUsageErrorMsg} />
      )}
      {(successMsg || printUsageSuccessMsg) && (
        <SuccessSnackbar successMsg={successMsg || printUsageSuccessMsg} />
      )}
    </div>
  );
};

export default FilterRuleGroupUsage;
